module.exports = __webpack_public_path__ + "static/img/tooltip-solar-panel-deployable-fixed.f4ba68e.png";